import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import type { EmailCredentials, EmailCredentialsMeta } from '@models';

type CallResult<T> = Promise<
  import('@angular/fire/functions').HttpsCallableResult<T>
>;

@Injectable({ providedIn: 'root' })
export class EmailSettingsService {
  private readonly functions = inject(Functions);

  /** Saves (or replaces) email provider credentials. Returns safe meta. */
  save(credentials: EmailCredentials): CallResult<EmailCredentialsMeta> {
    return httpsCallable<EmailCredentials, EmailCredentialsMeta>(
      this.functions,
      'saveEmailCredentials',
    )(credentials);
  }

  /** Returns metadata about stored credentials. Never returns actual secrets. */
  getMeta(): CallResult<EmailCredentialsMeta | null> {
    return httpsCallable<void, EmailCredentialsMeta | null>(
      this.functions,
      'getEmailCredentialsMeta',
    )();
  }

  /** Removes the tenant's email credentials, reverting to platform delivery. */
  delete(): CallResult<{ success: boolean }> {
    return httpsCallable<void, { success: boolean }>(
      this.functions,
      'deleteEmailCredentials',
    )();
  }
}
